import React from 'react';

import Tooltip from '@mui/material/Tooltip';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

import DynamicAvatar from '../../Shared/DynamicAvatar';

const TOOLTIP_CLASSES = '!text-base !text-main-normal !bg-background-normal !border !border-panels-normal !shadow-lg !rounded-input';
const AVATAR_TOOLTIP_CLASSES = '!bg-background-normal !border !border-panels-normal !shadow-lg !rounded-input !p-0';

export const MemberAvatarTooltipContent = ({members, maxVisible = 5}) => {
    if (!members.length) return null;
    const visible = members.slice(0, maxVisible);
    const remaining = members.length - maxVisible;

    return (
        <div className="flex items-center -space-x-1 p-1">
            {visible.map(m => (
                <Tooltip
                    key={m.id}
                    title={[m.FirstName, m.LastName].filter(Boolean).join(' ') || m.Email || ''}
                    enterDelay={200}
                    placement="top"
                    componentsProps={{tooltip: {className: TOOLTIP_CLASSES}}}
                >
                    <div>
                        <DynamicAvatar
                            user={{Name: m.FirstName, LastName: m.LastName}}
                            imageSrc={m.UserIcon}
                            style={{width: 24, height: 24, fontSize: 10, border: '1.5px solid var(--background-normal-color)'}}
                        />
                    </div>
                </Tooltip>
            ))}
            {remaining > 0 && (
                <span className="text-xs text-main-disabled ml-1.5">+{remaining}</span>
            )}
        </div>
    );
};

export const MixedDirectBadge = ({mixedInfo, targets}) => {
    const memberIds = mixedInfo?.memberIds || [];
    const members = targets.filter(t => memberIds.includes(t.id));
    if (!members.length) return null;

    return (
        <Tooltip
            title={<MemberAvatarTooltipContent members={members} />}
            placement="top"
            componentsProps={{tooltip: {className: AVATAR_TOOLTIP_CLASSES}}}
        >
            <WarningAmberIcon style={{fontSize: 14, color: 'var(--caution-warning-color)', marginLeft: 2, cursor: 'pointer'}} />
        </Tooltip>
    );
};
